import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GlobalStoreService } from '@principle-theorem/ng-principle-shared';
import { TypedFormControl, TypedFormGroup } from '@principle-theorem/ng-shared';
import {
  IStaffer,
  type ITyroTerminal,
} from '@principle-theorem/principle-core/interfaces';
import { DocumentReference } from '@principle-theorem/shared';

type EditTyroTerminalFormData = Pick<
  ITyroTerminal,
  'name' | 'mid' | 'tid' | 'practitionerRef'
>;

export interface IEditTyroTerminalRequest {
  title: string;
  formData?: Partial<EditTyroTerminalFormData>;
}

@Component({
  selector: 'pr-edit-tyro-terminal-dialog',
  templateUrl: './edit-tyro-terminal-dialog.component.html',
  styleUrls: ['./edit-tyro-terminal-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EditTyroTerminalDialogComponent {
  form = new TypedFormGroup<EditTyroTerminalFormData>({
    name: new TypedFormControl<string>(''),
    mid: new TypedFormControl<number>(),
    tid: new TypedFormControl<number>(),
    practitionerRef: new TypedFormControl<DocumentReference<IStaffer>>(
      undefined
    ),
  });

  constructor(
    private _dialogRef: MatDialogRef<
      EditTyroTerminalDialogComponent,
      ITyroTerminal
    >,
    @Inject(MAT_DIALOG_DATA) public data: Partial<IEditTyroTerminalRequest>,
    public globalStore: GlobalStoreService
  ) {
    if (data.formData) {
      this.form.patchValue(data.formData);
    }
  }

  submit(): void {
    if (!this.form.valid) {
      return;
    }
    this._dialogRef.close({ ...this.form.value, deleted: false });
  }
}
